import React from 'react';
import { 
	func, 
	array
} from 'prop-types';
import {} from '../../../logics/score';
export default class Container extends React.PureComponent {
	static propTypes = {
		render : func.isRequired,
		scores : array.isRequired
	}

	constructor(props) {
		super(props);
		this.state={
    		showMoreScore : false,
    	};
	}
	
	render(){
		const {render,scores:rawScores,...other} = this.props;
        
		const scores = rawScores.map(score=>{
			return {
				...score,
				localeDateTime : score.dateTime.toLocaleString(),
				percentScore : Math.round(score.normalizedScore * 100)
			};
		});
        
		const scoreCount = scores.length;
    	const average = scoreCount > 0 ? scores.reduce((accumulator,currentValue)=>accumulator+(currentValue.passed/currentValue.questionCount), 0.0) / scoreCount * 100: 0;
		return render({
			scores,
			scoreCount,
			average,
			showMoreScore : this.state.showMoreScore,
			onToggleShowMore : (more)=>()=>{
    			this.setState({showMoreScore:more});
    		},
		},other);
	}
}
